import { AxiosError } from 'axios';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    EProblemFeedback,
    EProblemFeedbackType,
    IProblemQuestion,
    IProblemResponse,
} from '../../models/Problems.interfaces';
import { literalsFeedback, LoaderMessage } from '../../pages/support/utils.chat';
import { nextQuestion } from '../../services/ProblemService';
import navigateParams from '../../utils/navigation/navigateParams';
import ChatDynamicResponse from '../ChatDynamicResponse';
import ChatSupport from '../ChatSupport';
import ChatText from '../ChatText';

const ChatDynamicQuestion = ({
    item,
    problemId,
    onQuestion,
    answer = false,
}: {
    item: IProblemQuestion;
    problemId: string;
    onQuestion: Function;
    answer?: boolean;
}) => {
    const navigate = useNavigate();
    const intervalTimout = useRef<number | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const handleNextQuestion = (response: IProblemResponse) => {
        setLoading(true);
        nextQuestion({ dialogId: item?.id, problemId, responseId: response.id })
            .then(() => {
                const _response = {
                    dialogId: item?.id,
                    next: true,
                    question: item,
                    response,
                };
                window.clearTimeout(intervalTimout.current!);
                setLoading(false);
                onQuestion(_response);
            })
            .catch((error: AxiosError) => {
                console.error(error);
                setLoading(false);
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.DIAGNOSIS,
                    ...literalsFeedback(EProblemFeedback.DIAGNOSIS),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
            });
    };

    const handleResponse = (response: IProblemResponse) => {
        handleNextQuestion(response);
    };

    return (
        <>
            <ChatSupport text={item?.question} html={true}></ChatSupport>
            {!answer ? (
                <ChatDynamicResponse
                    responses={item?.responses}
                    onSelected={(response: IProblemResponse) => {
                        handleResponse(response);
                    }}
                />
            ) : (
                <div className='chat-diagnosis__chatResponse'>
                    <ChatText context='response' text={item?.response?.text!}></ChatText>
                </div>
            )}
            {loading && LoaderMessage}
        </>
    );
};

export default ChatDynamicQuestion;
